// 数组转树
export const arr2Tree = (
  arr: any[] = [],
  options: {
    key?: string,
    titleKey?: string,
    titleWithKey?: boolean,
    parentKey?: string,
    childrenKey?: string,
  } = {},
) => {
  const {
    key = 'id',
    titleKey = 'name',
    titleWithKey = true,
    parentKey = 'parent_id',
    childrenKey = 'children',
  } = options;

  const result: any[] = [];
  const map = {};
  const data = arr.map((item: any) => {
    const newItem = {
      key: item[key],
      title: titleWithKey ? `#${item[key]} ${item[titleKey]}` : item[titleKey],
      parent_id: item[parentKey],
    };
    map[item[key]] = newItem;
    return newItem;
  });

  data.forEach((item: any) => {
    if (map[item[parentKey]]) {
      if (!map[item[parentKey]][childrenKey]) {
        map[item[parentKey]][childrenKey] = [];
      }
      map[item[parentKey]][childrenKey].push(item);
    } else {
      result.push(item);
    }
  });

  return result;
};

const flatMapRecursion = (tree: any, res: any[]) => {
  if (tree && tree.children && tree.children.length) {
    tree.children.forEach((item: any) => {
      flatMapRecursion(item, res);
    });
  } else {
    res.push(tree);
  }
};

// 展开拿到所有叶子节点
export const flatMapLeaves = (tree: any) => {
  const flatRes: any[] = [];
  if (Array.isArray(tree)) {
    tree.forEach((item) => {
      flatMapRecursion(item, flatRes);
    });
  } else {
    flatMapRecursion(tree, flatRes);
  }
  return flatRes;
};

export const flatMap = (tree: any) => {
  const flatRes: any = [];
  if (tree && tree.length) {
    tree.forEach((item: any) => {
      flatMapRecursion(item, flatRes);
    });
  }
  return flatRes;
};
